import React from 'react';
import { Grid, Paper } from '@mui/material';
import { useSelector } from 'store/hooks';
import DashboardListSortingTable from 'components/DashboardComponents/DashboardListTable/DashboardListSortingTable';
import KpiMetricsTable from './KpiMetricsTable/KpiMetricsTable';
import DashboardStats from 'components/DashboardComponents/DashboardStats';
import HalfPieChart from 'components/DashboardComponents/DashboardGraphs/HalfPieChart';

const KpiMetricsCoverRatio = ({ barChartData, metric, data_table, onDownloadXlsx, showDownload }) => {
  const { loadings } = useSelector((state) => state);

  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Paper
            elevation={5}
            sx={{
              boxShadow: '0px 3px 16px rgba(0, 0, 0, 0.15)',
              borderRadius: 2,
              p: 4,
              display: 'flex',
              flexDirection: 'column',
              gap: 1.25,
            }}
          >
            <DashboardStats coverratiodata={barChartData?.mission_list?.[0]} />
          </Paper>
        </Grid>
      </Grid>

      <Grid container spacing={3} sx={{ mt: 0.5 }}>
        {[{ title: 'Cover Ratio', data: barChartData, colors: {} }].map((item) => (
          <React.Fragment key={item.title}>
            {/* 1. Donut Chart Card */}
            <Grid item xs={12} sm={4} md={2} key={item.title}>
              <Paper
                sx={{
                  height: '284px',
                  flexGrow: 1,
                  flexBasis: 0,
                  borderRadius: 2,
                  p: 2,
                  boxShadow: '0px 3px 16px rgba(0, 0, 0, 0.15)',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <HalfPieChart title={item.title} barChartData={barChartData?.mission_list?.[0]} />
              </Paper>
            </Grid>

            <Grid item xs={12} sm={8} md={5}>
              <DashboardListSortingTable
                title="Missing Missions (by Customer)"
                tableTitle={{ name: 'Customer', secondName: 'Missions Nb' }}
                data={(item?.data?.customer_list ?? []) // Ensure it defaults to an empty array
                  .map((customer) => {
                    const rawName = customer?.name || '';
                    const formattedName = rawName
                      ? rawName.charAt(0).toUpperCase() + rawName.slice(1).toLowerCase()
                      : 'Unknown';

                    return {
                      name: formattedName,
                      value: customer.count,
                    };
                  })
                  .sort((a, b) => a.name.localeCompare(b.name))}
                metric={metric}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={5}>
              <DashboardListSortingTable
                title="Missing Missions(by BM)"
                tableTitle={{ name: 'BM', secondName: 'Nb Missions' }}
                data={(item?.data?.bm_list ?? []).map((bm) => {
                  const rawName = bm?.first_name + bm?.last_name || '';
                  const formattedName = rawName
                    ? rawName?.charAt(0)?.toUpperCase() + rawName?.slice(1)?.toLowerCase()
                    : '-';
                  return {
                    name: formattedName,
                    value: bm?.count,
                  };
                })}
                metric={metric}
              />
            </Grid>
          </React.Fragment>
        ))}
      </Grid>

      {/* Table Row */}
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2, borderRadius: 3 }}>
            <KpiMetricsTable
              FilterKpiMetric={metric}
              dashboardKpiGridData={data_table}
              FilterNeeded={false}
              isLoading={Boolean(loadings?.dashboardKpiGrid)}
              onDownloadXlsx={onDownloadXlsx}
              showDownload={showDownload}
            />
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default KpiMetricsCoverRatio;
